import {
  installAppRecovery,
  reportEntryLoadFailure,
} from "@/tools/appRecovery";

installAppRecovery();

void import("@app-entry").catch(reportEntryLoadFailure);
